<template>
  <DashboardTableWrapper
    title="Ventes recentes"
    :loading="loading"
    :error="error"
    :has-data="!!data && data.length > 0"
    @retry="refresh"
  >
    <table class="w-full text-sm">
      <thead>
        <tr class="bg-gray-50 text-left">
          <th class="px-4 py-3 font-semibold text-gray-600">N Facture</th>
          <th class="px-4 py-3 font-semibold text-gray-600">Date</th>
          <th class="px-4 py-3 font-semibold text-gray-600">Client</th>
          <th class="px-4 py-3 font-semibold text-gray-600">Vendeur</th>
          <th class="px-4 py-3 font-semibold text-gray-600">Total TTC</th>
          <th class="px-4 py-3 font-semibold text-gray-600">Statut</th>
          <th class="px-4 py-3 font-semibold text-gray-600">Type</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in data" :key="item.id" class="border-t border-gray-100 hover:bg-gray-50">
          <td class="px-4 py-3 font-medium text-gray-800">{{ item.invoice_number }}</td>
          <td class="px-4 py-3 text-gray-500">{{ formatDateDisplay(item.sale_date) }}</td>
          <td class="px-4 py-3 text-gray-600">{{ item.customer || '—' }}</td>
          <td class="px-4 py-3 text-gray-600">{{ item.user }}</td>
          <td class="px-4 py-3 font-semibold text-primary">{{ formatCurrency(item.total_ttc) }}</td>
          <td class="px-4 py-3">
            <BaseBadge :variant="statusVariant(item.status)" size="sm">
              {{ statusLabel(item.status) }}
            </BaseBadge>
          </td>
          <td class="px-4 py-3">
            <span class="inline-block px-2 py-1 text-xs font-semibold rounded-full" :class="typeClass(item.type)">
              {{ typeLabel(item.type) }}
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </DashboardTableWrapper>
</template>

<script setup>
import { computed } from 'vue'
import { useDashboard } from '@/composables/useDashboard'
import { useDateRange } from '@/composables/useDateRange'
import { formatCurrency } from './helpers'
import DashboardTableWrapper from './DashboardTableWrapper.vue'
import BaseBadge from '@/components/base/BaseBadge.vue'

const { dateParams } = useDateRange()

const params = computed(() => ({
  ...dateParams.value,
  limit: 10
}))

const { data, loading, error, refresh } = useDashboard('/dashboard/tables/recent-sales', params)

const statusLabels = {
  pending: 'En attente',
  partial_paid: 'Partiel',
  paid: 'Paye',
  completed: 'Termine',
  refunded: 'Rembourse',
  partial_refund: 'Remb. partiel'
}

const statusVariants = {
  pending: 'warning',
  partial_paid: 'info',
  paid: 'success',
  completed: 'success',
  refunded: 'danger',
  partial_refund: 'warning'
}

const typeLabels = {
  single: 'Comptant',
  deferred: 'Credit'
}

const typeClasses = {
  single: 'bg-blue-100 text-blue-800',
  deferred: 'bg-amber-100 text-amber-800'
}

const statusLabel = (s) => statusLabels[s] || s
const statusVariant = (s) => statusVariants[s] || 'gray'
const typeLabel = (t) => typeLabels[t] || t
const typeClass = (t) => typeClasses[t] || 'bg-gray-100 text-gray-600'

const formatDateDisplay = (d) => {
  if (!d) return ''
  return new Date(d).toLocaleDateString('fr-FR', { day: '2-digit', month: 'short', year: 'numeric' })
}
</script>
